
<script>
import {
  // fetchList,
  // reminder,
  updateRemark, // 入住说明添加
  getDetail, // 订单详情
  refundApi, // 订单退款
  cancleApi, // 取消订单
  editTouristApi, // 编辑客人信息
  cancleHotel, // 线下酒店订单取消(同退款)
  // offlinelist // 下线订单列表
  offlineDetail, // 线下订单详情
  examineOrder, // 线下订单审核
  confirmArrival, // 线下订单确认到店
  addremark, // 线下订单添加备注
  checkOut, // 离店退房
  refusedOrder, // 拒绝审核通过
  allproduct, // 新增其他费用下拉选择框的数据
  addotherfee, // 新增费用提交按钮
  otherfeelist // 查看其他费用详情
} from '@/api/order'
import { getPermission } from '@/utils/auth'
// import Cookies from 'js-cookie'
// import { constants } from 'crypto'
import Pagination from '@/components/Pagination'
import uFilter from './components/filter'
// import { numFormat } from '@/utils/com'
import { copy } from '@/utils/com'
export default {
  name: 'Base',
  components: { Pagination, uFilter },
  data() {
    return {
      pagePermission: getPermission()[`${this.$route.name}`],
      add_updateRemark: undefined,
      // 按钮权限列表
      butPer: {
        order_detail: true, // 详情
        order_cancel: false, // 取消订单
        order_add: false, // 新增/录入
        order_refund: false, // 退款
        order_refund_list: true, // 退款列表
        order_edit_tourist: false, // 编辑客人信息
        alp_offline_checkedOrder: false, // 审核
        alp_offline_confirmStartTime: false, // 确认到店
        alp_order_updateRemark: false, // 修改入住说明
        alp_offline_editTouristRoomNum: false, // 房间号修改
        club_free_entry_btn: false, // 靶场线下免费录入权限
        alp_offline_check_out: false // 酒店线下订单-离店退房
      },
      // 总页(分页)
      total: 0,
      tableKey: 0,
      // 列表数据
      list: [],
      // 详情数据
      details: null,
      listLoading: true,
      listQuery: {
        page: {
          order: 'id desc',
          limit: 30,
          page: 1
        },
        filter: {
          type: '',
          list_type: '',
          order_sn: undefined,
          username: undefined,
          order_status: undefined,
          product: undefined,
          product_model_id: undefined,
          client_type: undefined,
          source_type_id: undefined,
          start_time_start: undefined,
          start_time_end: undefined,
          end_time_start: undefined,
          end_time_end: undefined,
          created_start: undefined,
          created_end: undefined,
          approvalled_start: undefined,
          approvalled_end: undefined,
          refund_start: undefined,
          refund_end: undefined,
          remark: undefined,
          is_fullhour: undefined,
          sale_type: undefined,
          meal_type: undefined, // 套餐类型
          package_id: undefined, // 套餐类型2
          discount_type: undefined, // 折扣方式
          pay_fee_type: undefined, // 收款币种
          pay_type: undefined, // 收款方式
          actual_time_start: undefined, // 实际入住时间开始
          actual_time_end: undefined // 实际入住时间截止
        },
        select_order: undefined
      },
      // 汇总
      allConsume: {},
      // 订单状态
      order_status: {
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '0': this.$t('order.Tobesubmitted'), // 待提交
          '2': this.$t('order.Tobepaid'), // 待支付
          '3': this.$t('order.confirmed'), // 待确认库存
          '4': this.$t('order.Tobeused'), // 待使用
          '10': this.$t('order.Completed'), // 已完成
          '11': this.$t('order.Applicationforrefund'), // 申请退款
          '14': this.$t('order.Toberefunded'), // 待退款
          '15': this.$t('order.HasRefunded'), // 已退款
          '16': this.$t('order.Partialrefund'), // 部分退款
          '21': this.$t('order.Failuretopay'), // 支付失败
          '24': this.$t('order.Failureofrefund'), // 退款失败
          '23': this.$t('order.Refundauditfailed'), // 退款审核失败
          '31': this.$t('order.Paymentoverdue'), // 支付过期
          '32': this.$t('order.Cancellationoforder') // 取消订单
        }
      },
      order_status_hotel: {
        // 订单状态-酒店
        plac: this.$t('order.order_status'),
        val: '',
        options: {
          '0': this.$t('order.Tobesubmitted'), // 待提交
          '2': this.$t('order.Tobepaid'), // 待支付
          '3': this.$t('order.confirmed'), // 待确认库存
          '4': this.$t('order.Stayin'), // 待入住(与其他订单状态区别的地方)
          '5': this.$t('order.Checkedin'), // 已入住(与其他订单状态区别的地方)
          '10': this.$t('order.Completed'), // 已完成
          '11': this.$t('order.Applicationforrefund'), // 申请退款
          '14': this.$t('order.Toberefunded'), // 待退款
          '15': this.$t('order.HasRefunded'), // 已退款
          '16': this.$t('order.Partialrefund'), // 部分退款
          '21': this.$t('order.Failuretopay'), // 支付失败
          '24': this.$t('order.Failureofrefund'), // 退款失败
          '23': this.$t('order.Refundauditfailed'), // 退款审核失败
          '31': this.$t('order.Paymentoverdue'), // 支付过期
          '32': this.$t('order.Cancellationoforder') // 取消订单
        }
      },
      // 订单来源
      client_type: {
        plac: this.$t('order.client_type'),
        val: '',
        options: {
          '1': this.$t('order.Wechat'), // 微信公众号
          '2': this.$t('order.applet'), // 微信小程序
          '3': this.$t('order.Computer'), // 电脑端
          '4': this.$t('order.Undertheline'), // 线下
          '5': this.$t('order.Otherchannels') // 其它渠道
        }
      },
      // 房间类型
      room_type: {
        plac: this.$t('order.room_type'),
        val: '',
        options: {
          '1': this.$t('order.hotel.room_type_2_1'),
          '2': this.$t('order.hotel.room_type_2_2'),
          '3': this.$t('order.hotel.room_type_2_24'),
          '4': this.$t('order.hotel.room_type_3'),
          '5': this.$t('order.hotel.room_type_hour')
        }
      },
      // 时间选择
      chose_time: {
        created_start: {
          // 下单开始时间
          val: '',
          plac: this.$t('order.Startingorder')
        },
        created_end: {
          // 下单截止时间
          val: '',
          plac: this.$t('order.Deadlineorders')
        },
        start_time_start: {
          // 入住日期开始
          val: '',
          plac: this.$t('order.check_in_start')
        },
        start_time_end: {
          // 入住日期截止
          val: '',
          plac: this.$t('order.check_in_end') // this.$t('order.Checkdeadline')
        },
        end_time_start: {
          // 离店日期开始
          val: '',
          plac: this.$t('order.DepartureBegins')
        },
        end_time_end: {
          // 离店日期截止
          val: '',
          plac: this.$t('order.Departuredeadline')
        }
      },
      chose_time_arr: {
        created: [], // 下单开始时间
        start_time: [] // 办理入住日期
      },
      // 是否24小时入住
      is_fullhour: {
        plac: this.$t('order.Whether_hours'),
        val: '',
        options: [
          {
            id: 1,
            value: this.$t('order.yes')
          },
          {
            id: 2,
            value: this.$t('order.no')
          }
        ]
      },
      dialogVisible: false,
      dialogLoading: false,
      reasonVisible: false,
      editTouristloading: false,
      printViewShow: false,
      endterOrder: false, // 录入订单弹窗(靶场)
      detialVisible: false, // 订单详情(靶场)
      order_id: null,
      money: undefined,
      remark: '',
      refund_type: '1',
      dialogType: '',
      check_in_remark: undefined,
      examine_status: '', // 是否审核通过
      // 退款选项
      refundTypeOptions: {
        '1': this.$t('order.refundTypeOptions.Full_refund'), // '全额退款'
        '2': this.$t('order.refundTypeOptions.Partial_refund'), // '部分退款'
        '3': this.$t('order.refundTypeOptions.Refusal_refund') // '拒绝退款'
      },
      exportLoading: false,
      allproductList: [], // 新增其他费用下拉选择框的数据列表
      addData: null, // 新增费用
      gridData: [], // 列表查询新增费用
      row: {}
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  created() {
    // console.log(getPermission(), 88877)
    // console.log(this.$route.name)
    // console.log(getPermission()[`${this.$route.name}`], 77777)
    // 获取当前页权限
    this.getPagePermission()
  },
  methods: {
    /** 查看其他费用 */
    checkOtherfeelist(row) {
      this.gridData = []
      otherfeelist({
        filter: {
          order_sn: row.order_sn
        }
      }).then(res => {
        this.gridData = res.data
      })
    },
    /** 序号, , limit */
    indexMethod(index) {
      let page = this.listQuery.page.page
      let limit = this.listQuery.page.limit
      return (page - 1) * limit + index + 1
    },
    /** 复制文字 */
    copy,
    /** 获取当前时间 */
    formatDate(value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      let d_1 = date.getDate() + 1
      d = d < 10 ? '0' + d : d
      d_1 = d_1 < 10 ? '0' + d_1 : d_1
      let start_date = y + '-' + MM + '-' + d
      let end_date = y + '-' + MM + '-' + d_1
      let h = date.getHours()
      let m = date.getMinutes()
      let time_arr = [start_date, end_date, h, m]
      return time_arr
    },

    /** 获取当前页权限 */
    getPagePermission() {
      if (this.checkArr(this.pagePermission)) {
        for (let key in this.butPer) {
          this.butPer[`${key}`] = this.pagePermission.includes(key)
        }
      }
      if (!this.butPer.order_refund) {
        let pageName = this.$route.name
        let refundKey = pageName.substring(0, pageName.lastIndexOf('_list')) + '_refund'
        let refundPermission = getPermission()[`${refundKey}`]
        if (this.checkArr(refundPermission)) {
          this.butPer.order_refund = refundPermission.includes('order_refund')
        }
      }
      // console.log(this.butPer, 66666999999)
    },

    /** 查看是否为数组且长度>0 */
    checkArr(array) {
      if (array && array instanceof Array && array.length > 0) {
        return true
      } else {
        return false
      }
    },

    /** 分页选择 */
    paginationChange(query) {
      // console.log.log(query.page)
      this.listQuery.page.page = query.page
      this.listQuery.page.limit = query.limit
      this.getList()
    },

    /** 查看详情 */
    seeDetails(id, client_type) {
      var data = {
        order_id: id,
        client_type: client_type
      }
      this.dialogLoading = true
      if (this.$route.meta.list_type === 'OFFLINE') {
        offlineDetail(data).then(response => {
          this.details = response.data
          this.check_in_remark = this.details.remark
          this.money = response.data.real_amount
          this.dialogLoading = false
        })
      } else {
        getDetail(data).then(response => {
          this.details = response.data
          this.check_in_remark = this.details.remark
          this.money = response.data.real_amount
          this.dialogLoading = false
        })
      }
      this.dialogVisible = true
    },

    /** 查看靶场详情 */
    seeClubDetails(order_id) {
      this.order_id = order_id
      this.detialVisible = true
    },

    /** 选择退款类型 */
    typeChange(val) {
      if (val === '1') {
        this.money = this.details.real_amount
        this.remark = ''
      } else if (val === '3') {
        this.money = 0
      } else {
        this.money = undefined
      }
    },

    /** 退款金额限制 */
    refundMoney() {
      if (this.money > this.details.real_amount) {
        this.money = this.details.real_amount
      }
      if (this.money < 0) {
        this.money = 0
      }
    },

    /** 填写原因弹窗 */
    showDialog(type, row) {
      // 确认到店只在入住当天可操作
      if (type === 'confirmArrival') {
        let nowDate = new Date() // 获取当前时间
        nowDate.setTime(nowDate.getTime())
        let nowDate1 = `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}-${nowDate.getDate() + 1}` // 获取第二天00:00时间，当nowDate1小于到店时间(start_time)时，不可操作到店确认
        nowDate1 = new Date(nowDate1)
        let start_time = new Date(this.details.start_time) // 到店时间
        let end_time = new Date(this.details.end_time) // 离店时间
        if (nowDate1 <= start_time || nowDate > end_time) {
          this.$message({
            message: this.$t('order.cannotConfirmArrival'),
            type: 'warning'
          })
          return
        }
      }
      if (type === 'additional') {
        // 新增其他费用下拉选择框的数据
        allproduct({}).then(res => {
          this.allproductList = res.data
        })
      }
      this.row = row
      this.dialogType = type
      this.remark = ''
      this.reasonVisible = true
    },

    /** 提交 */
    submit(id, sn) {
      if (this.dialogType === 'refund') {
        // 订单退款
        this.refundOrder(id)
      } else if (this.dialogType === 'cancel') {
        // 取消订单
        this.cancleOrder(id)
      } else if (this.dialogType === 'examine') {
        // 审核订单
        this.examineOrder(id)
      } else if (this.dialogType === 'addremark') {
        // 添加备注
        this.addremark(id)
      } else if (this.dialogType === 'offline_cancel') {
        // 线下订单取消(等同于退款功能)
        this.offlineCancel(id)
      } else if (this.dialogType === 'confirmArrival') {
        // 确认到店
        this.confirmArrival(id)
      } else if (this.dialogType === 'CheckOut') {
        // 离店退房
        this.CheckOut(id)
      } else if (this.dialogType === 'additional') {
        // 新增其他费用
        this.additional(this.row.id, this.row.order_sn)
      }
    },

    /**  新增费用 */
    additional(id, sn) {
      console.log(id, sn)
      let data = {
        order_sn: sn, // 订单号
        product_id: this.addData.product_id || '', // 产品id
        product_num: this.addData.product_num * 1 || '', // 购买个数
        remarks: this.addData.remarks || '' // 备注
      }
      addotherfee({
        data: data
      }).then(res => {
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.addData = null
        this.row = {}
        this.dialogLoading = true
        this.dialogLoading = false
        this.reasonVisible = false
      })
    },

    /** 按钮提交 */
    subremark(query) {
      this.remark = query.remark
      this.examine_status = query.examine_status
      this.addData = query.addData
      if (this.dialogType === 'additional') {
        this.submit()
        return
      }
      this.submit(this.details.id, this.details.order_sn)
    },

    /** 订单退款 */
    refundOrder(id) {
      var data = {
        order_id: id,
        money: parseFloat(this.money),
        remark: this.remark,
        refund_type: this.refund_type
      }
      if (data.remark === '' && data.refund_type === '3') {
        this.$message.error(this.$t('order.refund_remark_null'))
        return
      } else {
        refundApi(data).then(res => {
          this.$message({
            message: this.$t('order.refund_success'),
            type: 'success'
          })
          this.reasonVisible = false
          this.dialogVisible = false
          this.getList()
        })
      }
    },

    /** 线下订单取消(等同于退款功能) */
    offlineCancel(id) {
      var data = {
        order_id: id,
        money: '',
        remark: this.remark,
        refund_type: '1'
      }
      if (data.remark === '') {
        this.$message.error(this.$t('order.cancel_remark_null'))
        return
      } else {
        cancleHotel(data).then(res => {
          this.$message({
            message: this.$t('order.cancel_success'),
            type: 'success'
          })
          this.reasonVisible = false
          this.dialogVisible = false
          this.getList()
        })
      }
    },

    /** 取消订单 */
    cancleOrder(id) {
      var data = {
        order_id: id,
        remark: this.remark || undefined
      }
      cancleApi(data).then(res => {
        this.$message({
          message: this.$t('order.cancel_success'),
          type: 'success'
        })
        this.reasonVisible = false
        this.dialogVisible = false
        this.getList()
      })
    },

    /** 添加入住说明  */
    addstyinremark(id) {
      if (this.details.remark.length === 0) {
        return
      } else if (this.check_in_remark === this.details.remark) {
        return
      }
      var data = {
        client_type: 'pc',
        data: {
          order_id: id,
          remark: this.details.remark || undefined
        }
      }
      updateRemark(data).then(res => {
        this.$message({
          message: this.$t('order.addcheck_in') + this.$t('setting.success'),
          type: 'success'
        })
        this.dialogLoading = true

        offlineDetail(data.data).then(response => {
          this.details = response.data
          this.check_in_remark = this.details.remark
          this.dialogLoading = false
          this.reasonVisible = false
        })
      })
    },

    /** 添加备注 */
    addremark(id) {
      var data = {
        order_id: id,
        remark: this.remark || undefined
      }
      addremark(data).then(res => {
        this.$message({
          message: this.$t('order.addremark') + this.$t('setting.success'),
          type: 'success'
        })
        this.dialogLoading = true
        offlineDetail(data).then(response => {
          this.details = response.data
          this.check_in_remark = this.details.remark
          this.dialogLoading = false
          this.reasonVisible = false
        })
      })
    },

    /** 审核订单 */
    examineOrder(id) {
      var data = {
        order_id: id,
        remark: this.remark || undefined
      }
      if (this.examine_status == '1') {
        // 通过审核
        examineOrder(data).then(
          res => {
            this.$message({
              message: this.$t('order.ExamineOrder') + this.$t('setting.success'),
              type: 'success'
            })
            this.dialogLoading = true
            offlineDetail(data).then(response => {
              this.details = response.data
              this.check_in_remark = this.details.remark
              this.dialogLoading = false
              this.reasonVisible = false
            })
            this.getList()
            this.dialogVisible = false
          },
          reason => {
            this.reasonVisible = false
          }
        )
      } else if (this.examine_status == '2') {
        refusedOrder(data).then(
          res => {
            this.$message({
              message: this.$t('order.ExamineOrder') + this.$t('setting.success'),
              type: 'success'
            })
            this.dialogLoading = true
            offlineDetail(data).then(response => {
              this.details = response.data
              this.check_in_remark = this.details.remark
              this.dialogLoading = false
              this.reasonVisible = false
            })
            this.getList()
            this.dialogVisible = false
          },
          reason => {
            this.reasonVisible = false
          }
        )
      }
    },

    /** 到店确认 */
    confirmArrival(id) {
      var data = {
        order_id: id
      }
      confirmArrival(data).then(res => {
        this.$message({
          message: this.$t('order.ConfirmArrival') + this.$t('setting.success'),
          type: 'success'
        })
        this.dialogLoading = true
        offlineDetail(data).then(response => {
          this.details = response.data
          this.check_in_remark = this.details.remark
          this.dialogLoading = false
          this.reasonVisible = false
        })
        this.getList()
        this.dialogVisible = false
      })
    },

    /** 离店退房 */
    CheckOut(id) {
      var data = {
        order_id: id,
        remark: this.remark
      }
      checkOut(data).then(
        res => {
          this.$message({
            message: this.$t('order.CheckOut') + this.$t('setting.success'),
            type: 'success'
          })
          this.dialogLoading = true
          offlineDetail(data).then(response => {
            this.details = response.data
            this.check_in_remark = this.details.remark
            this.dialogLoading = false
            this.reasonVisible = false
          })
          this.getList()
          this.dialogVisible = false
        },
        reason => {
          this.reasonVisible = false
        }
      )
    },

    /** 编辑游客信息 */
    editTourist(tourist) {
      this.editTouristloading = true
      let data = []

      tourist.forEach((item, index) => {
        data[index] = {
          tourist_id: item.tourist_id,
          tourist_name: item.name,
          tourist_id_no: item.id_no,
          tourist_id_type: 2,
          tourist_room_num: item.room_num,
          come_flight_num: item.come_flight_num,
          back_flight_num: item.back_flight_num
        }
      })
      editTouristApi(data).then(
        res => {
          // console.log.log(123)
          this.$message({
            message: this.$t('order.save_success'),
            type: 'success'
          })
          this.getList()
          offlineDetail({ order_id: this.details.id })
            .then(response => {
              this.details = response.data
              this.check_in_remark = this.details.remark
              this.editTouristloading = false
            })
            .catch(reason => {
              this.editTouristloading = false
            })
        },
        reason => {
          // console.log.log(reason)
          this.editTouristloading = false
        }
      )
    },

    /** 打开新页面打印 */
    printDetail() {
      localStorage.setItem('printDetails', JSON.stringify(this.details))
      let routeData = this.$router.resolve({
        path: '/printView'
      })
      window.open(routeData.href, '_blank')
    },

    /** 打开新页面打印 登记表 */
    printRegist() {
      localStorage.setItem('printDetails', JSON.stringify(this.details))
      let routeData = this.$router.resolve({
        path: '/printRegistration'
      })
      window.open(routeData.href, '_blank')
    },

    /** 获取订单来源 */
    room_type_list() {
      // order_source().then(response => {
      //   this.client_type.options = response.data
      // })
    },

    /** 获取靶场订单来源 */
    getClubFilterAllOptions() {}
  }
}
</script>

<style lang="scss">
.w140 {
  width: 140px;
}
.w160 {
  width: 160px;
}
.tourist .el-row:hover {
  background: rgb(236, 245, 255);
}
.tourist .el-row + .el-row {
  margin-top: 10px;
}
.tourist .el-input {
  width: auto;
  min-width: 120px;
}
.dialog2 {
  min-width: 1100px;
  max-width: 1260px;
}
.el-button--mini {
  padding: 7px;
}
.el-table .cell {
  text-overflow: clip;
}
</style>
